import { useContext, useState } from 'react'
import { AuthContext } from '../contexts/AuthContext'

const useItem = (initialItemState: any) => {
  const [interactiveState, setInteractiveState] = useState<any>({})
  const [item, setItem] = useState({
    ...initialItemState,
    bidHistory: { values: [], visible: false },
  })
  const { refreshUserData, instance } = useContext<any>(AuthContext)
  const updateItemProperty = async (propertyName: string, newValue: any) => {
    setItem((prev: any) => ({
      ...prev,
      [propertyName]: newValue,
    }))
    refreshUserData()
  }

  const toggleWatchlist = async (e: any) => {
    e.stopPropagation()
    e.preventDefault()
    let addedToWatchlist = interactiveState.addedToWatchlist
    if (addedToWatchlist === undefined) {
      addedToWatchlist = item.addedToWatchlist
    }
    addedToWatchlist = !addedToWatchlist

    setItem((prev: any) => ({
      ...prev,
      addedToWatchlist,
    }))
    setInteractiveState((prev: any) => ({
      ...prev,
      addedToWatchlist,
    }))

    if (addedToWatchlist) {
      await instance.post(`/watchlist/add?itemId=${item.id}`)
    } else {
      await instance.post(`/watchlist/delete?itemId=${item.id}`)
    }
    refreshUserData()
  }

  const handleSwitch = async (switchName: string) => {
    const itemPropertyName = `enable${switchName}`
    let targetValue = interactiveState[itemPropertyName]
    if (targetValue === undefined) {
      targetValue = item[itemPropertyName]
    }
    targetValue = !targetValue

    try {
      const {
        status,
        data: { success, message },
      } = await instance.post(
        `/notification/update${switchName}NotificationSetup/${item.id}/${targetValue}`
      )
      if (status === 200 && success) {
        setItem((prev: any) => ({
          ...prev,
          [itemPropertyName]: targetValue,
        }))
        setInteractiveState((prev: any) => ({
          ...prev,
          [itemPropertyName]: targetValue,
        }))
        await refreshUserData()
      }
    } catch (e) {
      console.error(e)
    }
  }

  const openBidHistory = async (e: any) => {
    e.stopPropagation()
    if (item.bidsCount && !item.bidHistory.visible) {
      const { data: bidHistoryResults } = await instance.get(
        `/bid/getBidsByItemId/${item.id}`
      )
      updateItemProperty('bidHistory', {
        values: bidHistoryResults,
        visible: true,
      })
    }
  }

  const closeBidHistory = () =>
    updateItemProperty('bidHistory', { values: [], visible: false })

  const setBidsCount = (val: number) => updateItemProperty('bidsCount', val)
  const setCurrentBid = (val: number) => updateItemProperty('currentBid', val)

  const updateItem = async (newData: any) => {
    setItem((prevState: any) => ({ ...prevState, ...newData }))
  }

  const itemHandler = {
    toggleWatchlist,
    openBidHistory,
    closeBidHistory,
    setBidsCount,
    setCurrentBid,
    updateItem,
    updateItemProperty,
    handleSwitch,
  }

  return {
    itemState: { ...item, ...interactiveState },
    setItemState: setItem,
    itemHandler,
  }
}

export default useItem
